import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankStatementImport  {
    _originalTypeClassName = "zERP.BO.BankStatementImport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankStatementImport.translate = translateService;
}
this.Sections = [];
this.Bank = new Domain.Bank();
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Sections:any;
Bank:any;
static setSections = ($this, items) => {
                if (items == null) items = [];
                if ($this.Sections == null) $this.Sections = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Sections.length > 0) {
                    Domain.BankStatementImport.removeSections($this, $this.Sections[0]);
                }

                Domain.BankStatementImport.addManySections($this, copyItems);
            }
static addManySections = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BankStatementImport.addSections($this, items[i]);
                }
            }
static addSections = ($this, item) => {
                if ($this.Sections == null) $this.Sections = [];
                if (item == null || $this.Sections.indexOf(item) > -1) return;
                $this.Sections.push(item);
}
static addRangeSections = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BankStatementImport.addSections($this, item));
            }
static removeSections = ($this, item) => {
                if ($this == null || $this.Sections == null || $this.Sections.indexOf(item) === -1) return;
                var _index = $this.Sections.indexOf(item);
                $this.Sections.splice(_index, 1);
}
static clearSections = ($this) => { $this.Sections = null; }
static setBank = ($this, value) => {
var oldValue = $this.Bank;
$this.Bank = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}